import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/Home.vue'),
	redirect: '/index', //重定向
	children: [
				{
					path: '/index',
					name: 'index',
					redirect: '/tongji', //重定向
					meta: { title: '首页' },
					component: () => import('@/views/Home.vue')
				},
				{
					path: '/tongji',
					name: 'tongji',
					meta: { title: '首页统计' },
					component: () => import('@/views/tongji/index.vue')
				},
				{
					path: '/workeorder',
					name: 'workeorder',
					meta: { title: '工单管理' },
					component: () => import('@/views/shengchan/workeorder.vue'),
				},
				{
					path: '/inventoryUnit',
					name: 'inventoryUnit',
					meta: { title: '库存单位' },
					component: () => import('@/views/inventoryUnit/inventoryUnit.vue'),
				},
				{
					path: '/createOperation',
					name: 'createOperation',
					meta: { title: '创建工序' },
					component: () => import('@/views/createOperation/createOperation.vue'),
				},
				{
					path: '/createProduct',
					name: 'createProduct',
					meta: { title: '创建产品' },
					component: () => import('@/views/createProduct/createProduct.vue'),
				},
				{
					path: '/processRoute',
					name: 'processRoute',
					meta: { title: '工艺路线' },
					component: () => import('@/views/processRoute/processRoute.vue'),
				},
				{
					path: '/performance',
					name: 'performance',
					meta: { title: '配置绩效' },
					component: () => import('@/views/performance/performance.vue'),
				},
				{
					path: '/workeorder',
					name: 'workeorder',
					meta: { title: '工单管理' },
					component: () => import('@/views/shengchan/workeorder.vue'),
				},
				{
					path: '/orderList',
					name: 'orderList',
					meta: { title: '报工列表' },
					component: () => import('@/views/baogong/orderList.vue'),
				},
				{
					path: '/gongzi',
					name: 'gongzi',
					meta: { title: '工资报表' },
					component: () => import('@/views/baogong/gongzi.vue'),
				},
				{
					path: '/orderDetail',
					name: 'orderDetail',
					meta: { title: '报工详情' },
					component: () => import('@/views/baogong/orderDetail.vue'),
				},
				
				{
					path: '/worker',
					name: 'worker',
					meta: { title: '工人账号' },
					component: () => import('@/views/account/worker.vue'),
				},
				{
					path: '/supervisor',
					name: 'supervisor',
					meta: { title: '主管账号' },
					component: () => import('@/views/account/supervisor.vue'),
				},
				{
					path: '/addWorderOrder',
					name: 'addWorderOrder',
					meta: { title: '创建工单' },
					component: () => import('@/views/addWorderOrder/index.vue'),
				},
				{
					path: '/setGongren',
					name: 'setGongren',
					meta: { title: '配置工人' },
					component: () => import('@/views/account/setGongren.vue'),
				}
				
	]
  },
 
  {
    path: '/login',
    name: 'login',
	meta: { title: '登陆页' },
    component: () => import('../views/Login/login.vue')
  },
]

const router = new VueRouter({
	 // mode: 'history',
  routes
})



export default router
